import api from './api';

export interface ScheduledPurchase {
  id: number;
  purchase_type: string;
  scheduled_date: string;
  estimated_amount?: number;
  location?: string;
  merchant_preference?: string;
  notes?: string;
  recommended_card?: number;
  recommended_card_detail?: {
    id: number;
    name: string;
    bank: {
      id: number;
      name: string;
      operating_category?: 'TRADITIONAL' | 'NON_TRADITIONAL' | 'UNKNOWN';
      is_traditional_bank?: boolean;
    };
    cashback_rate?: number;
    reward_points_rate?: number;
    _is_in_wallet?: boolean; // Backend validation flag
    // Analysis data from smart recommendations
    reward_type?: 'cashback' | 'points' | 'miles';
    reward_rate?: number;
    base_reward?: number;
    points_earned?: number;
    ttd_value?: number;
    estimated_cash_value?: number;
  };
  recommended_merchants?: Array<{
    merchant: string;
    discount: number;
    valid_to: string;
  }>;
  active_offers?: Array<{
    title: string;
    merchant: string;
    discount: number;
  }>;
  status: 'SCHEDULED' | 'COMPLETED' | 'CANCELLED';
  reminder_sent: boolean;
  created_at: string;
  updated_at: string;
  completed_at?: string;
}

export interface CreateScheduledPurchase {
  purchase_type: string;
  scheduled_date: string;
  estimated_amount?: number;
  location?: string;
  merchant_preference?: string;
  notes?: string;
}

export const planningService = {
  getScheduledPurchases: async (status?: 'SCHEDULED' | 'COMPLETED' | 'CANCELLED'): Promise<ScheduledPurchase[]> => {
    const params = status ? `?status=${status}` : '';
    const response = await api.get(`/planning/purchases/${params}`);
    return response.data;
  },

  getUpcomingPurchases: async (days: number = 7): Promise<ScheduledPurchase[]> => {
    const response = await api.get(`/planning/purchases/upcoming/?days=${days}`);
    return response.data;
  },

  createScheduledPurchase: async (data: CreateScheduledPurchase): Promise<ScheduledPurchase> => {
    const response = await api.post('/planning/purchases/', data);
    return response.data;
  },

  updateScheduledPurchase: async (id: number, data: Partial<CreateScheduledPurchase>): Promise<ScheduledPurchase> => {
    const response = await api.put(`/planning/purchases/${id}/`, data);
    return response.data;
  },

  deleteScheduledPurchase: async (id: number): Promise<void> => {
    await api.delete(`/planning/purchases/${id}/`);
  },

  completeScheduledPurchase: async (id: number): Promise<ScheduledPurchase> => {
    const response = await api.post(`/planning/purchases/${id}/complete/`);
    return response.data;
  },
  
  regenerateRecommendations: async (id: number): Promise<ScheduledPurchase> => {
    const response = await api.post(`/planning/purchases/${id}/regenerate/`);
    return response.data.purchase;
  },
};
